import { Component, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Subject, takeUntil } from 'rxjs';
import { DOC_STATE, TEST_CASE, UAT_DATA } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { UatPaymentDataType, UatPaymentMethodResponseType } from 'src/app/types/response/document-state.response.type';

@Component({
  standalone: false,
  selector: 'app-uat-input-payment',
  templateUrl: './uat-input-payment.component.html',
  styleUrl: './uat-input-payment.component.scss'
})
export class UatInputPaymentComponent {
  loading: boolean = true;
  current: number = 0;
  isMediumScreen: boolean = false;
  destroy$: Subject<void> = new Subject<void>();

  stepList: string[] = [
    'Payment Method',
    'Create (VA)',
    'Create (QRIS)',
    'Status Payment',
    // 'Cancel Payment'
  ];

  isConfirmBack: boolean = false
  @Output() openModalConfirmBack = new EventEmitter<boolean>();
  uatPaymentMethod: UatPaymentMethodResponseType[] = [];
  uatData: UatPaymentDataType[] = [];

  paymentMethod: UatPaymentMethodResponseType[] = [];
  createVa: UatPaymentMethodResponseType[] = [];
  createQris: UatPaymentMethodResponseType[] = [];
  statusPayment: UatPaymentMethodResponseType[] = [];
  cancelPayment: UatPaymentMethodResponseType[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private baseService: BaseService,
    private message: NzMessageService
  ) {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    setTimeout(() => (this.loading = false), 1000);
    this.route.queryParams.subscribe((params) => {
      this.current = +params['step'] - 1 || 0;
      this.getUatData();
    });
    if (localStorage.getItem('mode-uat-input-payment') === 'edit') {
      this.handleEdit();
    }
    this.getUatTestCase();
  }

  getUatTestCase() {
    this.baseService.getData(TEST_CASE + '/payment_service')
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: {data: UatPaymentMethodResponseType[]}) => {
        this.uatPaymentMethod = res.data;
        this.paymentMethod = res.data.filter(item => item.id === 22);
        this.createVa = res.data.filter(item => item.id >= 23 && item.id <= 26);
        this.createQris = res.data.filter(item => item.id >= 27 && item.id <= 29);
        this.statusPayment = res.data.filter(item => item.id >= 30 && item.id <= 32);
        this.cancelPayment = res.data.filter(item => item.id >= 33 && item.id <= 35);
      });
  }

  getUatData() {
    this.baseService.getData(UAT_DATA + '/payment_service')
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: {data: UatPaymentDataType[]}) => {
        this.uatData = res.data;
      }, (err) => {
        this.message.create('error', err.error.data.errors || 'Failed to get UAT Data')
      });
  }

  back(): void {
    this.isConfirmBack = true
  }

  closeConfirmBack() {
    this.isConfirmBack = false
  }

  next(): void {
    if (this.current < this.stepList.length - 1) {
      this.router.navigate(['/document/uat-input-payment'], {
        queryParams: { step: ++this.current + 1 },
      });
    }
  }

  previous(): void {
    if (this.current > 0) {
      this.router.navigate(['/document/uat-input-payment'], {
        queryParams: { step: --this.current + 1 },
      });
    }
  }

  handleEdit(): void {
    this.stepList.forEach((step) => localStorage.setItem(`uat-qrisly-${step.toLowerCase().replace(' ', '-')}`, 'complete'));
  }

  handleStep(targetStep: number): void {
    const steps = this.stepList.map(step => localStorage.getItem(`uat-qrisly-${step.toLowerCase().replace(' ', '-')}`));
    const maxCompletedStep = steps.findIndex(step => step !== 'complete') + 1 || this.stepList.length;
    if (targetStep <= maxCompletedStep) {
      this.router.navigate(['/document/uat-data-input-qrisly'], {
        queryParams: { step: targetStep },
      });
    } else {
      console.warn(`Navigation to step ${targetStep} is not allowed.`);
    }
  }

  checkScreenSize(): void {
    this.isMediumScreen = window.innerWidth < 1200;
  }

  updateState(): void {
    this.baseService.putData(DOC_STATE, { document_type: 'UAT', state: 4, service_types_id: 2 })
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.message.create('success', 'Succeeded in submitting UAT');
          this.router.navigate(['/document']);
          localStorage.removeItem('mode-uat-input-qrisly');
        },
        error: (err) => {
          this.message.error(err.error.meta.message || 'Failed to update state');
        }
      });
  }
}
